<div
  *ngIf="storeName?.active"
  class="flex flex-col items-center justify-center bg-zestNeutral py-[30px] px-5 lg:p-10"
>
  <div class="flex flex-col items-center justify-center">
    <h4 class="text-zestBlack text-base tracking-wide font-bold">
      {{ storeName?.storeName }}
    </h4>
    <h5 class="text-zestTertiary-500 text-sm tracking-wide text-center pt-2">
      {{ storeName?.address?.line1}}
    </h5>
  </div>

  <div class="flex flex-col lg:flex-row gap-2 lg:gap-5 items-center mt-5">
    <div
      *ngIf="storeName?.address?.phone"
      class="flex justify-start items-center"
    >
      <img
        class="pr-2 w-6"
        src="../../../assets/svg/Call.svg"
        alt="telephone"
      />
      <p class="text-zestBlack tracking-wider">
        {{ storeName?.address?.phone }}
      </p>
    </div>
    <div class="flex justify-start items-center">
      <img class="pr-2 w-6" src="../../../assets/svg/Message.svg" alt="email" />
      <p class="text-zestBlack tracking-wider">
        {{ storeName?.email || storeName?.merchant_email | lowercase }}
      </p>
    </div>
  </div>

  <div class="flex items-center mt-7">
    <img class="pr-2 w-7" src="../../../assets/svg/Lock.svg" alt="email" />
    <small class="block text-zestLabel font-semibold text-sm"
      >Secured By
      <a
        href="{{ setupStoreLink }}"
        target="_blank"
        rel="noopener"
        class="text-zestGreen"
        >Zest</a
      ></small
    >
  </div>
</div>

